const _excluded = ["startDate", "endDate", "onChange", "initialStartDate", "initialEndDate", "allowSameStartAndEndDate", "variant", "error", "format", "placeholder", "startDatePlaceholder", "endDatePlaceholder", "triggerProps", "setShouldShowSelection"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { useCallback } from 'react';
import { VALID_DATE_FORMATS } from '@adsk/alloy-react-datetime';
import { noop } from '@adsk/alloy-react-helpers';
import useDateRangeSelection from './useDateRangeSelection';
import useKeyDownHandler from './useKeyDownHandler';
import useSharedDateLogic from './useSharedDateLogic';
import { DATE_PICKER_VARIANTS } from '../consts';
import { getFieldValue } from '../helpers';
function useDateRangePicker(_ref) {
  let {
      /** core props */
      startDate: propsStartDate,
      endDate: propsEndDate,
      onChange: propsOnChange = noop,
      initialStartDate = null,
      initialEndDate = null,
      allowSameStartAndEndDate = false,
      /** picker props */
      variant = DATE_PICKER_VARIANTS.FIELD,
      /** trigger props */
      error,
      format = VALID_DATE_FORMATS.NUMERIC,
      placeholder,
      startDatePlaceholder,
      endDatePlaceholder,
      triggerProps,
      setShouldShowSelection
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    T,
    locale,
    minDate,
    maxDate,
    open,
    toggleOverlay,
    placement,
    arrowProps,
    targetProps,
    overlayProps,
    onFinalSelection,
    context
  } = useSharedDateLogic(props);
  const {
    startDate,
    endDate,
    onDateSelected,
    resetSelection
  } = useDateRangeSelection({
    initialStartDate,
    initialEndDate,
    propsStartDate,
    propsEndDate,
    propsOnChange,
    allowSameStartAndEndDate,
    onFinalSelection,
    setShouldShowSelection
  });
  useKeyDownHandler({
    open,
    resetSelection
  });
  const getTriggerProps = useCallback(() => {
    var _T$translate, _T$translate2, _T$translate3;
    return variant === DATE_PICKER_VARIANTS.FIELD ? _objectSpread(_objectSpread({
      disabled: props.disabled,
      error,
      range: true,
      open,
      variant,
      placeholder: (placeholder === null || placeholder === void 0 ? void 0 : placeholder.toString()) || ((_T$translate = T.translate('SELECT_DATE')) === null || _T$translate === void 0 ? void 0 : _T$translate.toString()),
      startDatePlaceholder: startDatePlaceholder || placeholder || ((_T$translate2 = T.translate('START_DATE')) === null || _T$translate2 === void 0 ? void 0 : _T$translate2.toString()),
      endDatePlaceholder: endDatePlaceholder || placeholder || ((_T$translate3 = T.translate('END_DATE')) === null || _T$translate3 === void 0 ? void 0 : _T$translate3.toString()),
      value: getFieldValue({
        startDate,
        endDate,
        range: true,
        format,
        locale
      })
    }, triggerProps), {}, {
      'data-testid': 'DateRangePickerTarget'
    }) : _objectSpread(_objectSpread({
      variant,
      disabled: props.disabled
    }, triggerProps), {}, {
      'data-testid': 'DateRangePickerTarget'
    });
  }, [variant, props.disabled, error, open, placeholder, T, startDatePlaceholder, endDatePlaceholder, startDate, endDate, format, locale, triggerProps]);
  return {
    context,
    minDate,
    maxDate,
    open,
    variant,
    endDate,
    startDate,
    toggleOverlay,
    getTriggerProps,
    onDateSelected,
    resetSelection,
    // useOverlay
    placement,
    arrowProps,
    targetProps,
    overlayContainerProps: overlayProps
  };
}
export default useDateRangePicker;
//# sourceMappingURL=useDateRangePicker.js.map